// extracted by mini-css-extract-plugin
export default {"container":"SectionContainerComponent_container__ToVux"};